import React, { Children } from 'react'
import { ListItem } from '@material-ui/core'

export default function MListItem(props) {
    const { children, ...otherProps } = props;
    return (
        <ListItem {...otherProps}>
            {children}
        </ListItem>
    )
}
